import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NAV_ITEMS } from '../../constants/constants';
import { NavItemModel } from '../../interface/interface';
import { ProfileService } from '../../services/profile.service';
import { SharedModule } from '../../shared.module';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Input() parentClass = '';
  @Output() onCloseSideBar: EventEmitter<any> = new EventEmitter();
  activeNav = '/';
  navItems: NavItemModel[] = [];
  subscriptions: Subscription = new Subscription();

  constructor(private router: Router, private profileService: ProfileService) {}

  ngOnInit(): void {
    this.activeNav = this.router.url;
    const sub = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.activeNav = this.router.url;
      });
    this.profileService.profileDetails.subscribe((profile) => {
      if (profile) {
        this.navItems = NAV_ITEMS[profile.role];
      }
    });
    this.subscriptions.add(sub);
  }

  closeSideBar() {
    this.onCloseSideBar.emit();
  }
}
